module.exports = __webpack_public_path__ + "static/unnamed-a4736680500042f52c7c1c2a22d1ffaa.jpg";